import type { CSSProperties } from 'react';
import { useMemo } from 'react';

const IMG_HOST =
  'https://www.mystargroup.jp/_cms_/wp-content/themes/mystargroup/_assets/img/';

interface ImgSlotProps {
  ratio?: string;
  label?: string;
  note?: string;
  style?: CSSProperties;
  corner?: boolean;
  src?: string;
  alt?: string;
}

export default function ImgSlot({
  ratio = '16/9',
  label = 'Image',
  note = '',
  style = {},
  corner = false,
  src = '',
  alt = '',
}: ImgSlotProps) {
  const id = useMemo(() => 'p' + Math.random().toString(36).slice(2, 8), []);
  const isLocal =
    src &&
    (src.startsWith('http') ||
      src.startsWith('assets/') ||
      src.startsWith('/') ||
      src.startsWith('./'));
  const full = src ? (isLocal ? src : IMG_HOST + src) : '';

  return (
    <div
      className={'img-slot' + (full ? ' has-img' : '')}
      style={{ aspectRatio: ratio, ...style }}
    >
      {full ? (
        <img
          className="img-slot-photo"
          src={full}
          alt={alt || note || label}
          loading="lazy"
        />
      ) : (
        <svg className="pattern" preserveAspectRatio="none">
          <defs>
            <pattern id={id} width="40" height="40" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1" fill="rgba(15,15,15,0.10)" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill={'url(#' + id + ')'} />
        </svg>
      )}
      {corner && <div className="corner" />}
    </div>
  );
}
